import { CheckCircle2, ShieldCheck } from "lucide-react";
import { Link } from "react-router";
import type { ProductDetail } from "@jipraks/shared";
import { buttonClassName } from "@client/components/ui/button-variants";
import { SpotlightCard } from "@client/components/ui/SpotlightCard";
import { catalogCopy } from "@client/locales/id/catalog";
import { PriceTag } from "./PriceTag";

const copy = catalogCopy.detail;

export function ProductPurchasePanel({ product }: { product: ProductDetail }) {
  return (
    <SpotlightCard className="p-6">
      <div className="flex flex-col gap-5">
        {product.isOwned ? (
          <p className="flex items-center gap-2 text-sm font-medium text-success">
            <CheckCircle2 className="size-4" aria-hidden="true" />
            {copy.ownedBadge}
          </p>
        ) : (
          <PriceTag price={product.price} normalPrice={product.normalPrice} size="lg" />
        )}

        {product.isOwned ? (
          <Link to={`/library/${product.slug}`} className={buttonClassName("primary", "lg", "w-full")}>
            {copy.openLibrary}
          </Link>
        ) : (
          // /checkout requires sign-in; the route guard sends visitors through Google first.
          <Link to={`/checkout/${product.slug}`} className={buttonClassName("primary", "lg", "w-full")}>
            {copy.buyNow}
          </Link>
        )}

        <p className="flex items-center gap-2 text-xs text-foreground-muted">
          <ShieldCheck className="size-4 shrink-0 text-accent-bright" aria-hidden="true" />
          {copy.lifetimeAccess}
        </p>
      </div>
    </SpotlightCard>
  );
}
